<template>
  <div class="input-group">
    <slot
      v-if="label"
      name="label"
      v-bind="{ label }">
      <label v-if="label">{{ label }}</label>
    </slot>
    <div class="input" :class="{
      [classes]: true,
      'border-danger': invalid,
      'border-primary': success,
      'pl-8 relative items-center': icon,
    }">
      <div
        class="input-prepend flex-shrink-0"
        v-if="this.$slots['input:prepend']">
        <slot name="input:prepend"></slot>
      </div>
      <template v-if="textarea">
        <textarea
          :placeholder="placeholder"
          :disabled="disabled"
          :rows="rows"
          @input="$emit('input', content)"
          @blur="($event) => $emit('blur', $event)"
          v-model="content"
          v-inputmask="inputmask"
          v-if="!!inputmask"></textarea>
        <textarea
          :placeholder="placeholder"
          :disabled="disabled"
          :rows="rows"
          @input="$emit('input', content)"
          @blur="($event) => $emit('blur', $event)"
          v-model="content"
          v-else></textarea>
      </template>
      <template v-else>
        <input
          :type="type"
          :placeholder="placeholder"
          :maxlength="maxInputLength"
          :disabled="disabled"
          :inputmode="inputMode || null"
          :enterkeyhint="enterKeyHint || null"
          @input="$emit('input', content)"
          @blur="($event) => $emit('blur', $event)"
          @keydown.enter="onEnter"
          v-model="content"
          v-inputmask="inputmask"
          v-if="!!inputmask">
        <input
          :type="type"
          :placeholder="placeholder"
          :maxlength="maxInputLength"
          :disabled="disabled"
          :inputmode="inputMode || null"
          :enterkeyhint="enterKeyHint || null"
          class="pl-6"
          @input="$emit('input', content)"
          @blur="($event) => $emit('blur', $event)"
          @click.stop="(($event) => $event)"
          @keydown.enter="onEnter"
          v-model="content"
          v-else>
          <img class="min-w-18px h-18px absolute left-20px" :src="image"  v-if="image" />
      </template>
      <div
        class="input-append flex-shrink-0"
        v-if="this.$slots['input:append']">
        <slot name="input:append"></slot>
      </div>
    </div>
    <div class="flex items-center flex-wrap mt-4 w-110" v-if="options && options.length">
      <span
      class="flex mr-8 mb-4 flex items-center"
      v-for="optionItem in options"
      :key="optionItem.id"
      >
        <label :class="[
        'text-sm text-primary font-bold underline cursor-pointer relative mb-0'
        ]">
          {{ optionItem.name }}
          <input class="opacity-0 w-full h-full absolute inset-0"
          v-model="optionItem.name"
          placeholder="Введите имя опции"
          @input="() => optionInput(optionItem.name)" />
        </label>
        <span class="ml-2 no-underline cursor-pointer"
        @click.stop.once="() => $emit('option-delete', optionItem.id)">
          <img class="w-2 min-w-2"
          src="@/assets/icons/modal-header-close.svg" alt="modal-header-close" />
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    value: {
      type: [String, Number],
      required: false,
    },
    maxInputLength: {
      type: String,
      default: '',
    },
    icon: {
      type: [String, Number],
      required: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false,
    },
    success: {
      type: Boolean,
      required: false,
      default: false,
    },
    classes: {
      type: String,
      required: false,
    },
    inputmask: {
      type: [String, Object],
      required: false,
    },
    inputMode: {
      type: String,
      required: false,
      default: '',
    },
    enterKeyHint: {
      type: String,
      required: false,
      default: '',
    },
    textarea: {
      type: Boolean,
      required: false,
      default: false,
    },
    rows: {
      type: Number,
      required: false,
      default: 5,
    },
  },
  data() {
    return {
      content: null,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.content = value;
      },
      immediate: true,
    },
  },
  computed: {
    image() {
      if (this.icon) {
        return `${process.env.VUE_APP_BASE_URL}/attach/${this.icon}`;
      }
      return '';
    },
  },
  methods: {
    onEnter(event) {
      if (this.enterKeyHint === 'search' && event) {
        event.preventDefault();
      }
      this.$emit('enter', this.content, event);
    },
    optionInput(name) {
      this.$emit('option-input', name);
    },
  },
};
</script>
